module.exports = __webpack_public_path__ + "img/photo-0068.f93e512e.jpg";